import * as notificationTypes from "./types";
import { uuidv4 } from "../../helpers/random";
import { deepCloneAndOmitAtIndex } from "../../helpers/state";

export default function notifications(state = [], action) {
    switch (action.type) {
        case notificationTypes.ADD_NOTIFICATION:
            const newMessage = {
                level: action.level,
                icon: action.icon,
                message: action.message,
                button: action.button,
                id: uuidv4()
            };
            return [...state, newMessage];

        case notificationTypes.REMOVE_NOTIFICATION:
            const { notificationId } = action;
            const notificationIndex = state.find(notification => {
                return notification.id === notificationId;
            });
            return notificationIndex
                ? deepCloneAndOmitAtIndex(state, notificationIndex)
                : state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/notifications/reducers.js